<template>
    <div class="PeerAllocationList">
        <div class="container-fluid">
          <div class="row vertical-align margin-top-1Point7Perc margin-bottom-2Perc">
            <div class="col-md-2 col-lg-2">
            </div>
            <div class="col-md-2 col-lg-2 font-weight-bold text-align-right">
              Boss User {{getCurrentIndex + 1}}:
            </div>
            <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-left-right-0Px">
                  <select class="form-control" v-model="selectedUserObj" :disabled="disableCurrentDropDown">
                    <option value=-1 disabled>Select</option>
                    <option v-for="peerObj in getPeerList" v-bind:key="peerObj.UserId" v-bind:value="peerObj">{{peerObj.FirstName + " " + peerObj.LastName}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-2 col-lg-2">
              <button class="btn btn-primary btn-block enroll-existing-button-BG black-font-color padding-left-right-0Px" v-on:click="showConfirmationPopUp($event)" :disabled="disableCurrentDropDown">Allocate</button>
            </div>
            <div class="col-md-2 col-lg-2">
            </div>
          </div>
          <span class="text-align-center font-size-20px" v-if="getAssignedPeerList.length > 0">
              Allocated to following peer(s): 
          </span>
          <div class="table-responsive margin-top-1Perc margin-bottom-2Perc margin-left-2Point7Perc" v-if="getAssignedPeerList.length > 0">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th class="text-align-center text-valign-middle font-size-15px border-right col-md-2 col-lg-2">Peer #</th>
                  <th class="text-align-center text-valign-middle font-size-15px border-right col-md-5 col-lg-5">Name</th>
                  <th class="text-align-center text-valign-middle font-size-15px col-md-5 col-lg-5">Email</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(assignedPeerObj, index) in getAssignedPeerList" :key="assignedPeerObj.UserId" :userObj="assignedPeerObj"> 
                  <td class="text-align-center text-valign-middle border-right col-md-2 col-lg-2">{{(index + 1)}}</td>
                  <td class="text-align-center text-valign-middle border-right col-md-5 col-lg-5">{{assignedPeerObj.FirstName + " " + assignedPeerObj.LastName}}</td>
                  <td class="text-align-center text-valign-middle col-md-5 col-lg-5">{{assignedPeerObj.Email}}</td>
                </tr>
              </tbody>
          </table>
          <hr width="77%" size="10px" class="margin-Top-4Perc"/>
        </div>
        <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="performOnConfirmationAction"></confirmation-alert>
        <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
        <!-- Show Spinner -->
        <div class="animationload" v-show="showSpinner">
          <div class="osahanloading"></div>
        </div> 
        <loader></loader>
        </div>    
    </div>    
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import { constants } from '@/utils/constants'
import { challengeService } from '@/server-util/challenge-service'
import AlertBox from '@/components/AlertOverlay'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
export default {
  props: ['currIndex', 'selectedFilterValuesObj', 'peerList'],
  created: function () {},
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      selectedUserObj: -1,
      showConfirmationBox: false,
      prefixString: '',
      postString: '',
      disableCurrentDropDown: false,
      assignedPeersList: []
    }
  },
  methods: {
    showConfirmationPopUp: function ($event) {
      if (this.selectedUserObj !== -1) {
        this.showConfirmationBox = true
        this.prefixString = 'Are you sure you want to perform the manual '
        this.postString = 'peer allocation for the user \'' + this.selectedUserObj.FirstName + ' ' + this.selectedUserObj.LastName + '\'?'
      } else {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a boss user ' + (this.getCurrentIndex + 1) + ' in order to perform manual peer allocation.'
      }
    },
    updateSelectedValues (value) {
      this.selectedFilterValuesObj = value
      this.getSubmittedUserResponses()
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    performOnConfirmationAction (value) {
      this.showConfirmationBox = false
      if (value) {
        this.doManualUserAllocation()
      }
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of delete element overlay
      this.showConfirmationBox = value
    },
    doManualUserAllocation: function () {
      var _this = this
      var storeObj = this.$store
      if (
        this.selectedFilterValuesObj !== undefined &&
        this.selectedFilterValuesObj !== '' &&
        this.selectedFilterValuesObj !== null &&
        this.selectedUserObj !== undefined &&
        this.selectedUserObj !== '' &&
        this.selectedUserObj !== null
      ) {
        _this.$store.state.isLoading = true
        challengeService
          .doManualAllocation(storeObj.state.access_token, this.selectedFilterValuesObj.selectedCohortObj.CohortId, this.selectedFilterValuesObj.selectedStepObj.ElemChallenge.ElementChallengeId, this.selectedUserObj.UserId)
          .then(
            responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                _this.submittedUserResponseList = responseObj.data
                _this.$store.state.isLoading = false
                _this.assignedPeersList = responseObj.data
                if (_this.assignedPeersList.length > 0) {
                  _this.disableCurrentDropDown = true
                } else {
                  _this.showAlertDialog = true
                  var fullName = this.selectedUserObj.FirstName + ' ' + this.selectedUserObj.LastName
                  _this.errorMsg = 'No Peer(s) are available for the allocation as \'' + fullName + '\'  might be already allocated to them. Please check the challenge report.'
                  _this.disableCurrentDropDown = false
                }
              } else {
                _this.disableCurrentDropDown = false
                // AK: Hide Spinner
                _this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg =
                  'Oops! Something went wrong. Please try again.'
              }
            },
            errorObj => {
              _this.disableCurrentDropDown = false
              // AK: Hide Spinner
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            }
          )
      } else {
        console.log(
          'Selected Filters or UserObj is NULL hence declined MANUAL PEER ALLOCATION OPERATION'
        )
      }
    }
  },
  components: {
    'confirmation-alert': ConfirmationOverlay,
    'alert-box': AlertBox,
    'loader': Loader
  },
  computed: {
    getSelectedFilterValuesObj: {
      get: function () {
        return this.selectedFilterValuesObj
      }
    },
    getCurrentIndex: {
      get: function () {
        return this.currIndex
      }
    },
    getPeerList: {
      get: function () {
        return this.peerList
      }
    },
    getCurrentSelectedStepObj: {
      get: function () {
        return this.getSelectedFilterValuesObj.selectedStepObj
      }
    },
    getCurrentSelectedStepName: {
      get: function () {
        return this.getCurrentSelectedStepObj.Title
      }
    },
    getAssignedPeerList: {
      get: function () {
        return this.assignedPeersList
      }
    }
  },
  watch: {},
  name: 'PeerAllocationList'
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.white-BG {
  background-color: #ffffff;
}
.MainDiv {
  overflow-y: hidden !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-Top-4Perc {
  margin-top: 4%;
}
.margin-Top-2Point5Perc {
  margin-top: 2.5%;
}
.align-center {
  margin: 0 auto !important;
}
.left-border {
  border-left: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.black-border {
  border: 1px solid black;
}
.grey-border {
  border: 1px solid #aaa;
}
.center-block {
  float: none;
  margin-left: auto;
  margin-right: auto;
}
.cursor-pointer {
  cursor: pointer;
}
.text-align-left {
  text-align: left !important;
}
.font-size-20px {
  font-size: 20px;
}
.font-weight-bold {
  font-weight: bold;
}
.width {
  width: 5% !important;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.margin-top-1Perc {
  margin-top: 1% !important;
}
.margin-bottom-1Perc {
  margin-bottom: 1%;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.float-right {
  float: right;
}
.enroll-existing-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color {
  color: #000;
}
.width {
  width: 95%;
}
.cursor-pointer {
  cursor: pointer;
}
.icon-width-height {
  width: 40px;
  height: 40px;
}
.img-align-middle{
    margin-left: auto;
    margin-right: 0px;
}
.text-decoration-none {
  text-decoration: none !important;
}
.padding-left-2Point7Perc{
  padding-left:2.7%;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
.border-right
 {
   border-right: 1px solid #aaa !important;
 }
.text-align-right{
  text-align: right !important;
}
.border-red {
  border: 1px solid red;
}
.margin-top-1Point7Perc {
  margin-top: 1.7%
}
.center-align {
    margin: auto;
    width: 20%;
    /* border: 3px solid green; */
    /* padding: 10px; */
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
  .table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
 }
 .text-align-center {
  text-align: center !important;
}
.font-size-15px {
  font-size: 15px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/users/challenge_allocation/PeerAllocationList.vue